<!-- Only a retailer has anything to filter here; the card used to render empty for everyone
     else, title and all. -->
@if (profile?.customer.isRetailer) {
  <app-filter-card
    i18n-heading
    heading="Verkaufsfilter"
    testId="invoice-order-filter"
    [canReset]="isFiltered"
    (reset)="resetFilter()"
  >
    <div class="col-12 col-md-3">
      <label for="invoiceOrderFilterCustomer" class="form-label" i18n>Kundenname/Nummer</label>
      <input
        id="invoiceOrderFilterCustomer"
        data-testid="invoice-order-filter-customer-input"
        class="form-control"
        type="text"
        [(ngModel)]="filter.customerNameOrNumber"
        (input)="searchThis()"
      />
    </div>
    <app-date-range-filter
      testId="invoice-order-filter-date"
      [(from)]="filter.dateFrom"
      [(to)]="filter.dateTo"
      (rangeChange)="searchThis()"
    ></app-date-range-filter>
  </app-filter-card>
}
